import {FC, useState} from 'react';

import {t} from 'i18next';

import {useAppSelector} from 'hooks';
import {useAppMode} from 'hooks/useAppMode';
import {useCarouselEventHandler} from 'hooks/useCarouselEventHandler';
import SendBrowserEvent from 'services/send-browser-event';
import {geSearchCarouselUrl, getBasketRecommendationTitle} from 'utils/recommendations';

import {StyledIFrame} from './styles/styledIFrame.style';

export const RecommendationsCarouselMFE: FC = () => {
  const {isExpress} = useAppMode();
  const {recommendations} = useAppSelector((state) => state.recommendations);

  const currentStore = useAppSelector((state) => state?.app?.currentStore);
  const {idToken: accessToken, customerId: userId} = useAppSelector((state) => state?.auth);

  const [isEmptyCarousel, setIsEmptyCarousel] = useState(false);

  const handleOnSeeAllClick = (analyticsPayload: any) => {
    SendBrowserEvent.goToPLP('recommendations', analyticsPayload);
  };

  useCarouselEventHandler({
    onSeeAllClick: handleOnSeeAllClick,
    onEmptyCarousel: (isEmpty: boolean) => {
      setIsEmptyCarousel(isEmpty);
    }
  });

  if (isEmptyCarousel) {
    return null;
  }
  return (
    <StyledIFrame
      src={geSearchCarouselUrl({
        title: `${t(getBasketRecommendationTitle(recommendations.recommendationType ?? ''))}`,
        stores: currentStore?.storeCodes || [],
        accessToken,
        isExpressMode: isExpress,
        recommendationVariant: 'basketRecommendation',
        userId,
        sameDay: currentStore?.isSameDayDelivery
      })}
      className={'iframeCarousel'}
    />
  );
};
